import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function toPath () {
  const paths = []
  for (let i = (arguments.length - 1); i >= 0; i--) {
    const path = arguments[i]
    if (!path) continue
    paths.unshift(path)
    if (/^\//.test(path)) {
      break
    }
  }
  return paths.join('/')
}

function makeRoute (routes) {
  const list = []
  for (let i in routes) {
    const route = routes[i]
    const children = route.children
    // 跳过含有link的路由
    if (route.link) continue
  
    if (Array.isArray(children)) {
      // 二级目录下的分组
      if (route.isGroup) {
        for (let i in children) {
          // 跳过二级目录含有link的路由
          if (children[i].link) continue
          // copy
          const child = { ...children[i] }
          // 连接组里的path
          if (route.path) {
            child.path = toPath(route.path, children[i].path)
          }
          list.push(child)
        }
      } else {
        // submenu
        list.push({
          ...route,
          children: makeRoute(children)
        })
      }
    } else {
      list.push(route)
    }
  }
  return list
}

class CoreRouter {
  constructor (options) {
    this.routes = []
    this.options = options || {}
  }

  push (route) {
    // [route, route]
    if (Array.isArray(route)) {
      for (let i = 0; i < route.length; i++) {
        if (Array.isArray(route[i].children)) {
          this.routes.push({
            ...route[i],
            children: makeRoute(route[i].children)
          })
        } else {
          this.routes.push(route[i])
        }
      }
    } else {
      if (Array.isArray(route.children)) {
        this.routes.push({
          ...route,
          children: makeRoute(route.children)
        })
      } else {
        this.routes.push(route)
      }
    }
  }

  router () {
    return new Router(Object.assign({}, this.options, { routes: this.routes }))
  }
}

export default CoreRouter
